module.exports = __webpack_public_path__ + "img/sleeve_cap_rise.31c112b9.png";